import { useEffect, useState } from "react";
import "./styles/indicadores.css";
import InternalError from "../generales/InternalError";
import { lang } from "../generales/traduction";
import { capitalizeFirstLetter } from "../../utils/utils";
import General from "./General";
import WorkStation from "./WorkStation";
import Printers from "./Printers";
import Phones from "./Phones";
import AccessPoint from "./AccesPoint";
import Switches from "./Switches";
import Routers from "./Routers";
import Laptops from "./Laptops";
import Fingerprints from "./Fingerprints";
import ModalHistoric from "./ModalHistoric";
import Modal from "react-modal";
import ModalEvents from "./ModalEvents";
import PanelDevice from "./PanelDevice";
import { useFetch } from "../../hooks/useFetch";
import { permisos_codigo_id } from "../generales/GroupsId";
import LoadData from "../LoadData";
import LoadSimple from "../LoadSimple";
import Select from "react-select";

const customSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: state.hasValue ? '#f0f9ff' : '#f8fafc',
    borderColor: state.isFocused || state.hasValue ? '#0ea5e9' : '#cbd5e1',
    boxShadow: state.isFocused ? '0 0 0 3px rgba(14,165,233, 0.1)' : 'none',
    borderRadius: '6px',
    minHeight: '38px',
    height: '38px',
    minWidth: '240px',
    cursor: 'pointer',
    '&:hover': {
      borderColor: state.isFocused || state.hasValue ? '#0ea5e9' : '#94a3b8'
    }
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '0 8px',
    height: '38px',
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: state.hasValue ? '#0ea5e9' : '#334155',
    fontWeight: '500',
    fontSize: '14px',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#334155',
    fontWeight: '500',
    fontSize: '14px',
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: '6px',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    zIndex: 9999
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#0ea5e9' : state.isFocused ? '#f0f9ff' : 'white',
    color: state.isSelected ? 'white' : '#334155',
    fontSize: '14px',
    cursor: 'pointer',
    '&:active': {
      backgroundColor: '#0ea5e9',
      color: 'white'
    }
  }),
  indicatorSeparator: () => ({
    display: 'none',
  })
};

const addHostModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width:'80%',
    height:'70%',
    padding:'20px'
  },
};
const PanelIndicadores = ({handleShowPopup,pageSelected, globals,server, dataGlobals,languaje,mode,estados_list,userPermissions,token,estadoSelected,setEstadoSelected}) => {
  const [listSelected, setListSelected] = useState(0);
  const [techSelected, setTechSelected] = useState(0);
  const [internalError,setInternalError]=useState(false)
  const [hostSelected,setHostSelected]=useState({})
  const dataTechs=useFetch('zabbix/groups/devices/0','',token,'GET',server)
  const dataServers=useFetch('zabbix/groups/server_techs','',token,'GET',server)
  const dataAgencies=useFetch('cassia/exception_agencies','',token,'GET',server)
  const dataCriticalities=useFetch('cassia/criticalities','',token,'GET',server)
  const hadleChangeList = (e,tite) => {
    setListSelected(e);
    setTechSelected(tite)
  };
  const [addHostModalOpen, setAddHostModalOpen] =useState(false);
  function openAddHostModal() {
      
    //   console.log('open')
      setAddHostModalOpen(true);
    }

  function closeAddHostModal() {
   
      setAddHostModalOpen(false);
  }
  function showHistoric(element){
    setHostSelected(element); // Esto debería funcionar si se pasa correctamente
    openAddHostModal();      // Esto también
}
  function getTechDisp(permissions, devices) {
  const moduleName = permissions.find(p => p.description === 'lista tecnologías')?.module_name;
  return devices.find(d => d.name === moduleName) ?? null;   // ← { dispId, name, id }
}
  useEffect(()=>{
    
        if(dataTechs.loading==false){
          const techPermissions = userPermissions
    .filter(p => p.description === 'lista tecnologías');

          // 2 .  Toma el primer permiso cuyo module_name NO sea "ODD"
          const chosenPerm = techPermissions.find(p => p.module_name !== 'ODD');

          // 3 .  Busca en devices el objeto cuyo name coincida
          const match = dataTechs.data.data.find(d => d.name === chosenPerm?.module_name) ?? null;

          // 4 .  Extrae lo que necesitas
          const result = match ? { dispId: match.dispId, name: match.name } : null;

          if (!userPermissions.some(
                                 (objeto) =>
                                   objeto.permission_id === permisos_codigo_id["General"])){
            hadleChangeList(result.dispId,result.name)
          }
        }
  },[dataTechs.loading])

  const [dataAnalisis,setDataAnalisis]=useState({data:{},loading:true,error:{}})
  const token_item=localStorage.getItem('access_token')
  function search_analisis(){
    setDataAnalisis({data:{},loading:true,error:dataAnalisis.error})
      const fetchData = async () => {
        // console.log(server.url+'/api/v1/cassia/diagnosta/'+data.ip)
        try {
          const response = await fetch(server.url+'/api/v1/zabbix/groups/devices', {                 
                                 headers: {
                                   'Content-Type': 'application/json',
                                   Authorization: `Bearer ${token_item}`,
                                 },
                               });
          // console.log(response)
          if (response.ok) {
            const response_data = await response.json();

            setDataAnalisis({data:response_data.data,loading:false,error:dataAnalisis.error})

            // setDataAnalisis(response_data.data)
          } else {
            throw new Error('Error en la solicitud');
          }
        } catch (error) {
        //   setInternalError(true)
        }
      };
      fetchData();
  }
  useEffect(()=>{
    if (userPermissions.some(
                          (objeto) =>
                            objeto.permission_id === permisos_codigo_id["General"])){
      search_analisis()
    }
   
  },[])
  function renderAdminComponent() {
    try {
        switch (listSelected) {
            case 0:
                return <General
                      mode={mode}
                      handleShowPopup={handleShowPopup}
                      server={server}
                      
                      languaje={languaje}
                    />
                ;
            case 2:
                return <WorkStation
                          mode={mode}
                          handleShowPopup={handleShowPopup}
                          server={server}
                          title='work station'
                          languaje={languaje}
                          hostSelected={hostSelected}
                                                                          setHostSelected={setHostSelected}
                                                                          openAddHostModal={openAddHostModal}
                                                                          showHistoric={showHistoric}
                        />
                    ;
                    case 3:
                        return <Printers
                                  mode={mode}
                                  handleShowPopup={handleShowPopup}
                                  server={server}
                                  title='Printer'
                                  languaje={languaje}
                                  showHistoric={showHistoric}
                                />
                            ;
                            case 4:
                                return <Phones
                                          mode={mode}
                                          handleShowPopup={handleShowPopup}
                                          server={server}
                                          title='Phone'
                                          languaje={languaje}
                                          showHistoric={showHistoric}
                                        />
                                    ;
                                    case 5:
                                        return <AccessPoint
                                                  mode={mode}
                                                  handleShowPopup={handleShowPopup}
                                                  server={server}
                                                  title='Acces Point'
                                                  languaje={languaje}
                                                  showHistoric={showHistoric}
                                                />
                                            ;
                                            case 6:
                                                return <Laptops
                                                          mode={mode}
                                                          handleShowPopup={handleShowPopup}
                                                          server={server}
                                                          title='Swhitch'
                                                          languaje={languaje}
                                                          showHistoric={showHistoric}
                                                        />
                                                    ;
                                                    case 7:
                                                        return <Fingerprints
                                                                  mode={mode}
                                                                  handleShowPopup={handleShowPopup}
                                                                  server={server}
                                                                  title='Router'
                                                                  languaje={languaje}
                                                                  showHistoric={showHistoric}
                                                                />
                                                            ;
                                                            case 8:
                                                                return <WorkStation
                                                                          mode={mode}
                                                                          handleShowPopup={handleShowPopup}
                                                                          server={server}
                                                                          title='Pagina Web'
                                                                          languaje={languaje}
                                                                          hostSelected={hostSelected}
                                                                          setHostSelected={setHostSelected}
                                                                          openAddHostModal={openAddHostModal}
                                                                          showHistoric={showHistoric}
                                                                        />
                                                                    ;
            // case "mantto-calendar":
            //     return <PanelCalendario handleShowPopup={handleShowPopup} languaje={languaje} mode={mode}  server={server}  setInternalError={setInternalError}/>;
            // case "noti-user":
            //     return <NotifiAdmin languaje={languaje} mode={mode} server={server} setInternalError={setInternalError}/>;
            // case "noti-tec":
            //     return <NotifiTech languaje={languaje} mode={mode} server={server} setInternalError={setInternalError}/>;
            default:
                return <></>;
        }
    } catch (error) {
        console.error('Error rendering component:', error);
        return <div>{lang[languaje['msgErrorPagina']]}</div>;
    }
  }
  return (
    <>
    <div className={"main-config"+mode}>
       {/* {(internalError)?
            <InternalError/>
            :renderAdminComponent()} */}
       <div className='pi-premium-header'>
            <div className='pi-tabs-group'>
               {(userPermissions.some((objeto) => objeto.permission_id === permisos_codigo_id["General"])) ? (
                  <button 
                     className={`pi-tab-btn ${listSelected === 0 ? 'active' : ''}`} 
                     onClick={() => hadleChangeList(0, '')}>
                     {capitalizeFirstLetter(lang[languaje]['general'] || 'General')}
                  </button>
               ) : null}

               <div className="pi-dropdown-container">
                  <Select 
                     styles={customSelectStyles}
                     placeholder="Seleccionar Tecnología..."
                     isSearchable={true}
                     isLoading={dataTechs.loading}
                     noOptionsMessage={() => "Sin tecnologías"}
                     value={
                       listSelected === 0 || dataTechs.loading
                         ? null 
                         : dataTechs.data.data
                             .filter(element => element.dispId === listSelected)
                             .map(element => ({ value: element.dispId, label: element.name }))[0] || null
                     }
                     options={
                       dataTechs.loading 
                         ? [] 
                         : dataTechs.data.data
                             .filter((element) => userPermissions.some((objeto) => objeto.permission_id === permisos_codigo_id[element.name]))
                             .map((element) => ({ value: element.dispId, label: element.name }))
                     }
                     onChange={(selectedOption) => {
                        if (selectedOption) {
                           hadleChangeList(selectedOption.value, selectedOption.label);
                        }
                     }}
                  />
               </div>
            </div>
       </div>
            <div className='cont-monitor'>
            {(internalError)?
            <InternalError/>
            :(dataTechs.loading)?<LoadSimple/>:((listSelected==0)?renderAdminComponent():
            <PanelDevice 
            key={listSelected}
            mode={mode}
            dataServers={dataServers}
            techSelected={techSelected}
            listSelected={listSelected}
                          handleShowPopup={handleShowPopup}
                          server={server}
                          title='work station'
                          languaje={languaje}
                          hostSelected={hostSelected}
                          dataCriticalities={dataCriticalities}  dataAgencies={dataAgencies}
                                                                          setHostSelected={setHostSelected}
                                                                          openAddHostModal={openAddHostModal}
                                                                          showHistoric={showHistoric}
            />
            )}
            
                
            </div>
    </div>
    <Modal
    isOpen={addHostModalOpen}
    // isOpen={true}
    // onAfterOpen={afterOpenExeption}
    onRequestClose={closeAddHostModal}
    style={addHostModalStyles}
    contentLabel="Example Modal2"
    // shouldCloseOnOverlayClick={false}
    >
      <ModalEvents dataCriticalities={dataCriticalities}  dataAgencies={dataAgencies} dataServers={dataServers} deviceId={listSelected} server={server} handleShowPopup={handleShowPopup}  hostSelected={hostSelected}  languaje={languaje}  mode={mode} closeAddHostModal={closeAddHostModal} ></ModalEvents> 
      {/* <ModalHistoric  server={server} handleShowPopup={handleShowPopup}  hostSelected={hostSelected}  languaje={languaje}  mode={mode} closeAddHostModal={closeAddHostModal} ></ModalHistoric> */}
</Modal>
{/* <Modal
    isOpen={addHostModalOpen}
    // isOpen={true}
    // onAfterOpen={afterOpenExeption}
    onRequestClose={closeAddHostModal}
    style={addHostModalStyles}
    contentLabel="Example Modal2"
    // shouldCloseOnOverlayClick={false}
    >
      <ModalHistoric  server={server} handleShowPopup={handleShowPopup}  hostSelected={hostSelected}  languaje={languaje}  mode={mode} closeAddHostModal={closeAddHostModal} ></ModalHistoric>
</Modal> */}

</>
  );
};

export default PanelIndicadores;
